import { useState } from 'react';
import Image from 'next/future/image';
import cn from 'classnames';
import chevronRight from '@/public/icons/product/chevronRight.svg';
import { ParseMarkdown } from '@/components/markdown';

const QualityPackagingSlideDown = ({
  categorySummary,
}: {
  categorySummary: string;
}) => {
  const [show, setShow] = useState(false);

  const toggleQualityPackaging = () => {
    setShow(!show);
  };

  return (
    <div className="text-sm">
      <button
        type="button"
        onClick={() => toggleQualityPackaging()}
        className="flex w-full items-center justify-between gap-3 p-4"
      >
        <h3 className="text-left font-bold">Certified Quality & Packaging</h3>
        <div
          className={cn('h-3 w-3', {
            'rotate-90': !show,
            'rotate-[270deg]': show,
          })}
        >
          <Image
            src={chevronRight}
            alt="Chevron Right"
            className="h-full w-full"
            height={25}
            width={25}
          />
        </div>
      </button>
      <div
        className={cn('overflow-auto transition-all duration-500 ease-in-out', {
          'max-h-[1000px]': show,
          'max-h-0': !show,
        })}
      >
        <div className="flex flex-col bg-white px-4 pb-4 text-[14px]">
          <div className="w-full">
            <ParseMarkdown
              markdown={categorySummary}
              variables={{}}
              size="base"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QualityPackagingSlideDown;
